var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 511.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M10.44 0h196.59c5.75 0 10.45 4.7 10.45 10.44v196.59c0 5.75-4.7 10.45-10.45 10.45H10.44C4.7 217.48 0 212.78 0 207.03V10.44C0 4.7 4.7 0 10.44 0zm294.52 294.48h196.59c5.74 0 10.45 4.69 10.45 10.44v196.6c0 5.74-4.71 10.44-10.45 10.44H304.96c-5.75 0-10.45-4.7-10.45-10.44v-196.6c0-5.75 4.7-10.44 10.45-10.44zm0-294.48h196.59C507.29 0 512 4.7 512 10.44v196.59c0 5.75-4.71 10.45-10.45 10.45H304.96c-5.75 0-10.45-4.7-10.45-10.45V10.44c0-5.74 4.7-10.44 10.45-10.44zM10.44 294.48h196.59c5.75 0 10.45 4.69 10.45 10.44v196.6c0 5.74-4.7 10.44-10.45 10.44H10.44C4.7 511.96 0 507.26 0 501.52v-196.6c0-5.75 4.7-10.44 10.44-10.44z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.014d5a40d94c22666c3b1bdf752c69a8.svg";
export { ForwardRef as ReactComponent };